import React from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash-es';
import { Button } from '../../../../../components';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import styles from '../../styles.module.scss';

const cx = classNames.bind(styles);

const SportHeroButton = ({ ctaObject = {}, chosenSport, chosenCity }) => {
  const { text = '', url = '', newTab } = ctaObject;

  if (url) {
    return (
      <a href={url} rel="noreferrer" target={newTab ? '_blank' : '_self'}>
        <Button className={cx('ctaButton')}>{text || `Play ${_.capitalize(chosenSport)}`}</Button>
      </a>
    );
  }
  return (
    <Link
      to={{
        pathname: '/discover',
        search: `?cityName=${chosenCity}&sportNames[]=${chosenSport}`,
      }}
      target={newTab ? '_blank' : '_self'}
    >
      <Button className={cx('ctaButton')}>{text || `Play ${_.capitalize(chosenSport)}`}</Button>
    </Link>
  );
};

SportHeroButton.propTypes = {
  ctaObject: PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string,
    newTab: PropTypes.bool,
  }),
  chosenSport: PropTypes.string.isRequired,
  chosenCity: PropTypes.string.isRequired,
};

SportHeroButton.defaultProps = {
  ctaObject: {},
};

export default SportHeroButton;
